<template>
    <div class="step-header" :class="{ animate: animate }">
        <div class="icon" v-if="icon" v-html="$icon(icon)"></div>

        <div class="step" v-if="showStep">
            <span>{{ currentStep }}</span
            >/{{ totalSteps }}
        </div>

        <h2 class="title">
            {{ title }}
        </h2>

        <h3 class="subtitle">
            {{ subtitle }}
        </h3>
    </div>
</template>

<script>
export default {
    props: {
        icon: String,
        showStep: {
            type: Boolean,
            default: false
        },
        currentStep: [String, Number],
        totalSteps: [String, Number],
        title: [String],
        subtitle: [String]
    },

    data() {
        return {
            animate: false
        };
    },

    mounted() {
        this.animate = false;

        setTimeout(() => (this.animate = true), 200);
    },

    beforeDestroy() {
        this.animate = false;
    }
};
</script>

<style lang="scss">
.step-header {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 45px;
    padding-bottom: 45px;
    text-align: center;
    max-width: 691px;
    margin: auto;

    @media all and (max-width: $mobile) {
        padding-top: 25px;
        padding-bottom: 25px;
    }

    .icon {
        width: 194px;
        height: 194px;
        box-shadow: 0 25px 50px 0 rgba(0, 84, 255, 0.08);
        background-color: $white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 35px;
        transition: opacity 0.3s ease-in-out;
        opacity: 0;

        @media all and (max-width: $mobile) {
            width: 156px;
            height: 156px;
        }
    }

    .step {
        margin-bottom: 28px;
        font-size: 20px;
        font-weight: $font-light;
        line-height: 1.3;
        color: $black;
        transition: opacity 0.2s ease-in-out;
        opacity: 0;

        span {
            font-weight: bold;
            color: $primary-blue;
        }
    }

    h2.title {
        font-size: 45px;
        font-weight: $font-bold;
        line-height: 52px;
        color: $black;
        transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
        opacity: 0;
        transform: translateY(20px);

        @media all and (max-width: $mobile) {
            font-size: 20px;
            font-weight: bold;
            line-height: 1.3;
            letter-spacing: normal;
            color: $black;
        }
    }

    h3.subtitle {
        font-size: 25px;
        font-weight: $font-normal;
        line-height: normal;
        color: rgba(0, 0, 0, 0.5);
        transition: opacity 0.4s ease-in-out, transform 0.4s ease-in-out;
        opacity: 0;
        transform: translateY(30px);

        @media all and (max-width: $mobile) {
            font-size: 20px;
            font-weight: $font-light;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.3;
            letter-spacing: normal;
            color: $black;
        }
    }

    &.animate {
        .icon {
            opacity: 1;
        }

        .step {
            opacity: 1;
        }

        h2.title {
            opacity: 1;
            transform: translateY(0);
        }

        h3.subtitle {
            opacity: 1;
            transform: translateY(0);
        }
    }
}
</style>
